const config = {
  apiGateway: {
    URL: process.env.REACT_APP_API_URI,
  },
};

export default config;